import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../shared/services/auth/auth.service';
import { TabStripComponent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  showMessages: any;
  showNews: any;
  showTracker: any;

  initialLoading = false;
  @ViewChild('hometabstrip') tabstrip: TabStripComponent;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    setTimeout(() => {
      this.showMessages = this.authService.getDarkKeyValue('Messages');
      this.showNews = this.authService.getDarkKeyValue('News');
      this.showTracker = this.authService.getDarkKeyValue('Task Tracker');
    }, 500);
  }

  ngAfterViewChecked() {
    this.setTabStripStyle();
  }

  setTabStripStyle() {
    const allDetails = document.querySelectorAll('.k-tabstrip');
    if (allDetails && allDetails.length > 0) {
      allDetails.forEach(details => {
        const firstChild = details.firstElementChild.children[0];
        if (firstChild && firstChild.children && firstChild.children.length > 1) {
          const elArr = Array.from(firstChild.children) as Array<HTMLElement>;
          const tabFirstEl = Array.from(elArr[0].children) as Array<HTMLElement>;
          const tabSecEl = Array.from(elArr[1].children) as Array<HTMLElement>;
          tabFirstEl[0].style.marginRight = '5px';
          tabSecEl[0].style.marginRight = '5px';
          elArr.forEach(element => {
            element.style.width = 100 / firstChild.children.length + '%';
          });
        }
      });
    }
  }
}
